import Tooltip from '@material-ui/core/Tooltip';
import KebabMenu from '../../core/KebabMenu';
import { NavLink } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/AssignmentInd';
import CheckCirclOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles as styles } from '../style/gstheme';
import { PACKAGES } from '../utils/constants';

class SubscriptionCard extends Component {

  render() {

    const { classes, subscriptionIRI, approved, active, selectSubscription,
      cancelled, subscriptionType, cancelSubscription, updateSubscription, cancellable,
      expirationDate, name, subscriptionPackage, maxUsers } = this.props;

    const date = expirationDate ? new Date(expirationDate) : null;
    const dateText = date ? date.toLocaleString().substring(0, 10) : "";

    return (
      <React.Fragment>
        <div data-test={"subscription-" + name}>
          <div data-test={active ? 'active-subscription-card'
            :
            approved ?
              'nonactive-subscription-card'
              :
              'unapproved-subscription-card'
          }>
            <Paper
              data-test={"subscription-card-" + subscriptionIRI}
              key={subscriptionIRI}
              className={active ?
                classes.activeSubscriptionCard
                :
                approved ?
                  classes.subscriptionCard
                  :
                  classes.unapprovedSubscriptionCard
              }
              onClick={() => approved ? selectSubscription(subscriptionIRI) : null}>
              <div style={{ display: 'flex' }}>
                <Typography
                  data-test='subscription-card-title'
                  className={classes.subHeadingLarge}
                  style={{ flex: 1, ...(active) && { color: 'white' } }}>{name}</Typography>
                {cancellable && !expirationDate && subscriptionType !== "Trial" && !cancelled &&
                  <div style={{ flex: '0 0', alignSelf: 'right', transform: 'translatey(-5px)' }}>
                    <KebabMenu
                      items={["Cancel Subscription", "Update Payment Method"]}
                      colour={active ? "white" : null}
                      onSelect={(index) => index === 0 ? cancelSubscription(subscriptionIRI) : updateSubscription(subscriptionIRI)}
                    />
                  </div>
                }
              </div>
              <Typography
                variant="body2"
                style={{
                  marginTop: 6,
                  ...(active) && { color: 'white' }
                }}>{PACKAGES[subscriptionPackage]}</Typography>
              <Typography
                variant="body2"
                style={{
                  marginTop: 6,
                  ...(active) && { color: 'white' }
                }}>{subscriptionType}</Typography>
              <div data-test="subscription-enddate" style={{ flex: 1, minHeight: 20 }}>
                {expirationDate && <Typography variant="body2" style={{
                  marginBottom: 10,
                  marginTop: 6,
                  color: active ? 'white' : '#CA4F0C'
                }}>This subscription ends {dateText}</Typography>}
                {cancelled && !expirationDate && <Typography variant="body2" style={{
                  marginBottom: 10,
                  marginTop: 6,
                  color: active ? 'white' : '#CA4F0C'
                }}>This subscription has been cancelled</Typography>}
              </div>
              {approved === false &&
                <div data-test="unapproved-subscription" style={{ flex: 1, minHeight: 20 }}>
                  <Typography variant="body2" style={{
                    marginBottom: 10,
                    marginTop: 6,
                    color: '#CA4F0C'
                  }}>This subscription is being prepared</Typography>
                </div>
              }
              <div style={{ flex: '0 0' }}>
                <div style={{ paddingTop: 12 }}>
                  {active && <Typography data-test="active-subscription" variant="body2">
                    <CheckCirclOutlineIcon style={{ verticalAlign: 'bottom' }} />
                    <span> Active</span>
                  </Typography>}
                </div>
              </div>
              <div style={{ flex: '0 0' }}>
                <div style={{ height: 40 }}>
                  {active &&
                    <div style={{ float: 'right' }}>
                      <Tooltip title="Go to subscription">
                        <IconButton
                          aria-label={"Go to subscription " + name}
                          data-test="go-to-active"
                          size="small"
                          style={{ width: 40, height: 40, verticalAlign: 'middle', paddingTop: 8, paddingBottom: 6 }}>
                          <NavLink aria-label={"Go to subscription " + name} to={"/"} className={classes.cardLink}>
                            <ArrowForwardIcon className={classes.actionButton} />
                          </NavLink>
                        </IconButton>
                      </Tooltip>
                    </div>
                  }
                  <Typography data-test="max-subscription-users" variant="body2" style={{ flex: '0 0', paddingTop: 12 }}>
                    <AssignmentIcon style={{ verticalAlign: 'bottom' }} />
                    <span> Max {maxUsers} users</span>
                  </Typography>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SubscriptionCard.defaultProps = {
  active: false,
  cancelled: false
};

SubscriptionCard.propTypes = {
  classes: PropTypes.object,
  approved: PropTypes.bool.isRequired,
  subscriptionIRI: PropTypes.string.isRequired,
  cancelled: PropTypes.bool,
  cancellable: PropTypes.bool,
  cancelSubscription: PropTypes.func.isRequired,
  updateSubscription: PropTypes.func.isRequired,
  active: PropTypes.bool,
  expirationDate: PropTypes.number,
  selectSubscription: PropTypes.func.isRequired,
  subscriptionType: PropTypes.string,
  name: PropTypes.string.isRequired,
  subscriptionPackage: PropTypes.string.isRequired,
  maxUsers: PropTypes.number.isRequired
};

export default withStyles(styles)(SubscriptionCard);